import {
  REQUEST_SERVICE_GEOMETRIES,
  RECEIVE_SERVICE_GEOMETRIES,
} from 'ondemand/actions/serviceGeometries';


export default (state = {}, action) => {
  switch (action.type) {
    case REQUEST_SERVICE_GEOMETRIES:
      return Object.assign({}, state, {
        isFetchingInfo: true,
      });
    case RECEIVE_SERVICE_GEOMETRIES:
      return Object.assign({}, state, {
        isFetchingInfo: false,
        info: action.info,
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/ondemand/reducers/serviceGeometries.js